export const GET_DEALER_DATA_REQUEST = 'GET_DEALER_DATA_REQUEST';
export const GET_DEALER_DATA_SUCCESS = 'GET_DEALER_DATA_SUCCESS';
